import { render, staticRenderFns } from "./slices-block.vue?vue&type=template&id=1e21b1fd&"
import script from "./slices-block.vue?vue&type=script&lang=js&"
export * from "./slices-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports